export const theBeginning = () => 0;
